"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    baseRequirements: {
        'algebra i': 1,
        geometry: 1
    },
    oneAdditionalCredit: {
        'math appl in ag/food/& nat res': 1,
        'math models with applications': 1,
        'digital electronics': 1,
        'robotics programming & design': 1,
        'financial mathematics': 1,
        'applied mathematics for technical professionals': 1,
        'accounting ii': 1,
        'manufacturing engineering technology ii': 1,
        'algebra ii': 1,
        'precalculus': 1,
        'advanced quant reasoning': 1,
        'indep study in math': 1,
        'discrete math for prblm solvng': 1,
        'algebraic reasoning': 1,
        'ap statistics': 1,
        'ap computer science a': 1,
        'engineering mathematics': 1,
        'statistics and business decision making': 1,
        'mathematics for medical professionals': 1,
        'discrete math for comp science': 1,
        'robotics ii': 1,
        "colge prep course mathematics": 1,
        "fundamentals of comp science": 1,
        "ib computer science, highr lvl": 1,
        "ib computer science, std level": 1,
        "ib further mthematics high lvl": 1,
        "ib mathematical studies stan.": 1,
        "ib mathematics higher level": 1,
        "ib mathematics standard level": 1,
        "linear algebra": 0.5,
        "multivariable calculus": 1,
        "number theory": 0.5,
        "statistics": 1,
        "strategic learn f/hs math": 1
    }
};
//# sourceMappingURL=math.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/core/math.js
// module id = 447
// module chunks = 22